import { emptyObject } from 'Lib/constants/placeholder';

const isEmptyTypeGuard = <T>(value: T | typeof emptyObject): value is typeof emptyObject =>
  value === emptyObject;

export default isEmptyTypeGuard;
